import React, { forwardRef, ButtonHTMLAttributes } from "react";
import classNames from "classnames";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faXmark } from "@fortawesome/pro-regular-svg-icons";
import { useTranslation } from "react-i18next";

import { Slot } from "components/slot";
import { useBottomSheetContext } from "./bottomSheetContext";

export type CloseProps = ButtonHTMLAttributes<HTMLButtonElement> & {
  /** Merge props onto the child instead of rendering a <button>. */
  asChild?: boolean;
};

export const Close = forwardRef<HTMLButtonElement, CloseProps>(
  (
    { className, onClick, children, asChild = false, "aria-label": ariaLabel, type = "button", ...rest },
    ref,
  ) => {
    const { t } = useTranslation();
    const { setOpen } = useBottomSheetContext();
    const Comp = asChild ? Slot : "button";
    const content =
      asChild || children ? children : <FontAwesomeIcon icon={faXmark} style={{ width: 16, height: 16 }} />;

    return (
      <Comp
        {...rest}
        ref={ref}
        type={asChild ? undefined : type}
        className={asChild ? className : classNames("ui-bottom-sheet-dialog-close", className)}
        aria-label={ariaLabel || (children || asChild ? undefined : t("Close"))}
        onClick={event => {
          onClick?.(event as React.MouseEvent<HTMLButtonElement>);
          if (event.defaultPrevented) {
            return;
          }
          setOpen(false, "close-press");
        }}
      >
        {content}
      </Comp>
    );
  },
);

Close.displayName = "BottomSheet.Close";
